import React from 'react'
import { IStyle, mergeStyleSets, ActionButton, IIconProps, FontWeights, ICommandBarItemProps, Stack } from 'office-ui-fabric-react';
import { NotificationListItem, ISearchResult, ISearchSuggestion, CoherenceHeader, CoherencePanelSize } from '@cseo/controls';
import { FontSizes } from '@cseo/styles';
import { getUserSession } from './common/util';
import { SessionStorageConsts } from '../../models/SessionStorageConsts';
import { UIControlsText } from '../../content/UIControlsText';
import { getRuleValidationMessage, getEntityDataFromSession } from "./common/util";
import { MessageTypeText } from "../../models/MessageTypeText";
import { buttonStyles, feedbackButtonStyle } from '../../content/styles/Page.styles';
import { DefaultButton, IButtonProps } from '@fluentui/react';

const FeedbackButton: React.FC<any> = (props) => (
    <ActionButton {...props} styles={feedbackButtonStyle}>{getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "FeedbackButtonLabel", UIControlsText.FeedbackButtonLabel)}</ActionButton>
);

const renderStyledCommandBarButton = (item: ICommandBarItemProps) => (    
            <DefaultButton
            key={item.key}
            text={getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "FeedbackButtonLabel", UIControlsText.FeedbackButtonLabel)}
            onClick={(ev) => item.onClick && item.onClick(ev as React.MouseEvent<HTMLElement, MouseEvent>)}    
        styles={feedbackButtonStyle} />
);

const sessionResourceData = getEntityDataFromSession<any>(SessionStorageConsts.resourceStrings);

interface HeaderProps {
    onShowMoreResultsCallback?: (searchtext: string, searchResults: ISearchResult[]) => void;
    onFeedbackClick: () => void;    
}
type PivotOption = 'general' | 'releaseNote' | 'criticalNotification';

interface HeaderState {
    newNotifications: number;
    notificationItems: NotificationListItem[];
    showDismissAllBool: boolean;
    ocvButtonIsFocused: boolean;
    dismissOpenedPanel?: boolean;
    searchResults: ISearchResult[];
    recentSearchTexts: ISearchSuggestion[];
    selectedPivot: PivotOption;
    userName: string;
    emailAddress: string;
}

// #region Notification Panel
const initialNotifications: NotificationListItem[] = [];

const openItem = (itemKey: string) => {
    const items = initialNotifications.filter(notificationItem => notificationItem.itemKey === itemKey);
    alert('Open notification: ' + items[0].subjectHeader + (items[0].senderName ? ' from ' + items[0].senderName : ''));
}
// #endregion

export class Header extends React.Component<HeaderProps, HeaderState> {
private headerContainerRef = React.createRef<HTMLDivElement>();

constructor(props: HeaderProps) {
    super(props);
    this.state = {
            newNotifications: 0,
            notificationItems: initialNotifications,
            showDismissAllBool: false,
            ocvButtonIsFocused: false,
            dismissOpenedPanel: undefined,
            searchResults: [],
            recentSearchTexts: [],
            selectedPivot: 'general',
            userName: '',
            emailAddress: ''
        };
    }
    componentDidMount() {
        var userDetails = getUserSession()
        let fullName = ""
        let email = ""
        if (userDetails != null) {
            let loggedInUserInfo = JSON.parse(userDetails);
            fullName = loggedInUserInfo.firstName + ' ' + loggedInUserInfo.lastName
            email = loggedInUserInfo.email
            this.setState({ userName: fullName });
            this.setState({ emailAddress: email });
        }
        //Accessibility Fix to Add Heading Level
        var pageHeading = document.querySelectorAll(`a[aria-label= '${ getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "PageHeaderLabel", UIControlsText.PageHeaderLabel) }']`);
        pageHeading && pageHeading.forEach((element) => {
            element.setAttribute("role", "heading");
            element.setAttribute("aria-level", "1");
        });
        // Accessibility Fix: CoherenceHeader renders role="menubar" with direct button children
        // (Share Feedback, profile icon, notifications), which violates WCAG 1.3.1 (aria-required-children).
        // This is not a real ARIA menubar, so role="menubar" is removed from the container and
        // role="menuitem" is removed from all direct button children, since these are standalone
        // action buttons and not true menu items. This resolves both:
        //   - WCAG 1.3.1 aria-required-children (menubar must contain menuitem children)
        //   - WCAG 1.3.1 aria-required-parent (menuitem must be inside menu/menubar/group)
        // The query is scoped to headerContainerRef to avoid affecting unrelated menus on the page.
        // Defer the DOM fix with setTimeout to ensure CoherenceHeader has fully rendered
        // its internal elements before we attempt to query and modify them.
        setTimeout(() => {
        if (this.headerContainerRef.current) {
            const headerMenubar = this.headerContainerRef.current.querySelector('[role="menubar"]');
            if (headerMenubar) {
                headerMenubar.removeAttribute('role');
                headerMenubar.querySelectorAll('[role="menuitem"]').forEach((item) => {
                    item.removeAttribute('role');
                });
            }
        }
        }, 0);
    }

    // #region   Notification Panel States Private Functions
    private _onDismiss = (id: string[]): void => {
        this.setState({ showDismissAllBool: true });
    };

    private _updateItem = (
        itemKey: string,
        dStatus: NotificationListItem['displayStatus'],
        rStatus?: NotificationListItem['status']
    ) => {
        const list = [...this.state.notificationItems];
        list.map((item) => {
            if (item.itemKey === itemKey) {
                item.displayStatus = dStatus;
                if (rStatus) {
                    item.status = rStatus;
                }
            }
        });
        this.setState({ notificationItems: list });
    };

    private _updateItemDisplayStatus = (): void => {
        this.setState({ newNotifications: -1 });
    };

    private _onUndoDismissAll = () =>
        this.setState({ showDismissAllBool: false });
    // #endregion

    private _getHeaderMessage = () : JSX.Element | null => {
        var message = null
        if(process.env.REACT_APP_ENVTYPE !== undefined && process.env.REACT_APP_ENVTYPE === getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "TestEnvType", UIControlsText.TestEnvType)) {
            message = <span className={this.headerStyles.root}>{ " - " + getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "PageHeaderLabelTestEnv", UIControlsText.PageHeaderLabelTestEnv) }</span>;
        }
        return message;
    }

    public render(): JSX.Element {
        return (
            <div ref={this.headerContainerRef}>
            <CoherenceHeader
            headerLabel={getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "PageHeaderLabel", UIControlsText.PageHeaderLabel)}
            appNameSettings={{
                // @ts-ignore
                label: <div>{getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "PageHeaderLabel", UIControlsText.PageHeaderLabel)}{this._getHeaderMessage()}</div>,
                linkUrl: process.env.REACT_APP_HOME_PAGE_URI || ""
            }}
            farRightSettings={{
                profileSettings: {
                fullName: this.state.userName,
                emailAddress: this.state.emailAddress,
                imageUrl: '',
                logOutLink: process.env.REACT_APP_RSLR_LOGOUT_API_URI || "",
                body: <div />,
                onLogOut: (() => this._onLogout())
                },            
            additionalItems: [
                {
                    key: 'userFeedback',
                    onClick: () => this.props.onFeedbackClick(),
                    commandBarButtonAs: renderStyledCommandBarButton,                    
                }
            ]
            }}
            dismissOpenedPanel={this.state.dismissOpenedPanel}
            onDismissOpenedPanel={() => {
                this.setState({ dismissOpenedPanel: undefined });
            }}
            styles={{
                dividerStyle: {
                height: '0px',
                marginBottom: '0px',
                marginTop: '0px',
                }
            }}
            />
            </div>
        );
    }

    private settingsStyles = mergeStyleSets({
        root: {
            marginLeft: '-10px',
            marginRight: '-10px'
        } as IStyle
    });

    private headerStyles = mergeStyleSets({
        root: {
            color: '#FF7F50',
        } as IStyle
    });

    // #region   Help Panel 
    private helpLinkStyles = mergeStyleSets({
        helpLink: {
            margin: '8px 0',
            display: 'block',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.semibold
        } as IStyle,
        helpList: {
            listStyle: 'none',
            paddingLeft: '0'
        } as IStyle
    });
    // #endregion

    // #region   Settings Panel 
    private settingsIcon: IIconProps = { iconName: 'Settings' };

    private ringerIcon: IIconProps = { iconName: 'Ringer' };

    private favoriteStarIcon: IIconProps = { iconName: 'FavoriteStar' };

    private touchIcon: IIconProps = { iconName: 'Touch' };

    private settings: JSX.Element = (
        <div className={this.settingsStyles.root}>
            <ul className={this.helpLinkStyles.helpList}>
                <li>
                    <ActionButton iconProps={this.settingsIcon}>
                        General
                    </ActionButton>
                </li>
                <li>
                    <ActionButton iconProps={this.ringerIcon}>
                        Notifications
                    </ActionButton>
                </li>
                <li>
                    <ActionButton iconProps={this.favoriteStarIcon}>
                        Favorites
                    </ActionButton>
                </li>
                <li>
                    <ActionButton iconProps={this.touchIcon}>
                        Accessibility
                    </ActionButton>
                </li>
            </ul>
        </div>
    );

    // #endregion

    private _onLogout() {
        // Remove user session saved data from sessionStorage
        sessionStorage.removeItem(SessionStorageConsts.loggedInUserInfo);
        // Remove all saved data from sessionStorage
        sessionStorage.clear();
    }
    // #endregion
}